import { useStyles } from '@webapps/styles';
import NewModal from './NewModal';
import { Button } from '@material-ui/core';

const ConfirmModal = ({ open, onCancel, onConfirm, textObject }) => {
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);



  return (
    <NewModal open={open} onCancel={onCancel}>
      <div className={classes.container}>

        <div className={classes.title}>
          {textObject.title}
        </div>
        <div className={classes.description}>
          {textObject.description}
        </div>

        <div className={classes.buttons}>
          <Button
            variant="contained"
            color="primary"
            onClick={onConfirm}
          >
            {textObject.confirmText}
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={onCancel}
          >
            {textObject.cancelText}
          </Button>
        </div>
      </div>
    </NewModal>
  );
};

const styles = ({ spacing }) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    borderRadius: "20px",

    ".MuiInputBase-root": {
      borderRadius: "10px !important",
    }
  },
  header: {
    alignItems: "center",
    backgroundColor: "#f3f7ff",
    borderTopLeftRadius: "20px",
    borderTopRightRadius: "20px",
    display: "flex",
    flexDirection: "column",
    padding: "24px",
    width: "100%",
    gap: "30px",
    overflow: "visible",
  },
  logo: {
    aspectRatio: "2.02054 / 1",
    width: "166px",
    position: "relative",
    overflow: "visible",
  },
  headerText: {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    width: "388px",
    gap: "10px",
    overflow: "hidden",
  },
  title: {
    fontFamily: '"Montserrat", sans-serif',
    fontSize: "24px",
    fontWeight: "600",
    lineHeight: "28px",
    textAlign: "center",
    color: "#152652",
    width: "100%",
  },
  description: {
    fontFamily: '"Roboto", sans-serif',
    fontSize: "14px",
    lineHeight: "18px",
    textAlign: "center",
    color: "#5d75a8",
    width: "100%",
  },
  shareButton: {
    border: "1px solid #c0d9ff",
    backgroundColor: "#f3f7ff",
    borderRadius: "20px",
    display: "flex",
    height: "26px",
    width: "26px",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    overflow: "visible",
    "&:hover": {
      borderColor: "#0060f9",
      "& $shareIcon": {
        fill: "#0060f9",
      },
    },
  },
  shareIcon: {
    height: "16px",
    width: "16px",
    fill: "#5d75a8",
  },
  form: {
    alignItems: "flex-start",
    backgroundColor: "#ffffff",
    borderBottomLeftRadius: "20px",
    borderBottomRightRadius: "20px",
    display: "flex",
    flexDirection: "column",
    padding: "24px",
    width: "100%",
    gap: "20px",
    overflow: "hidden",
  },
  inputGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    width: "100%",
    position: "relative",
    overflow: "hidden",
  },
  label: {
    fontFamily: '"Roboto", sans-serif',
    fontSize: "14px",
    lineHeight: "15px",
    color: "#92abd2",
  },
  inputButton: {
    border: "1px solid #c0d9ff",
    backgroundColor: "#f3f7ff",
    borderRadius: "10px !important",
    display: "flex",
    height: "40px",
    justifyContent: "space-between",
    padding: "5px 15px",
    width: "100%",
    alignItems: "center",
    position: "relative",
    overflow: "visible",
    "&:hover": {
      borderColor: "#0060f9",
      "& $inputText": { color: "#0060f9" },
      "& $selectionText": { color: "#0060f9" },
      "& $iconRight": { fill: "#0060f9" },
    },
  },
  inputText: {
    fontFamily: '"Montserrat", sans-serif',
    fontSize: "13.5px",
    fontWeight: "500",
    lineHeight: "23.625px",
    textAlign: "center",
    color: "#92abd2",
  },
  selectionText: {
    fontFamily: '"Montserrat", sans-serif',
    fontSize: "13.5px",
    fontWeight: "500",
    lineHeight: "23.625px",
    textAlign: "center",
    color: "#5d75a8",
  },
  iconRight: {
    height: "24px",
    width: "24px",
    fill: "#5d75a8",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(2, minmax(50px, 1fr))",
    gridTemplateRows: "repeat(2, minmax(0px, 1fr))",
    gap: "20px",
    width: "100%",
    overflow: "hidden",
  },
  validateButton: {
    backgroundColor: "#0060f9",
    borderRadius: "40px",
    display: "flex",
    height: "40px",
    padding: "5px 15px",
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
    overflow: "visible",
    "&:hover": {
      backgroundColor: "#004ac1",
    },
  },
  deleteButton: {
    backgroundColor: "#F50057",
    "&:hover": {
      backgroundColor: "#BD0042",
    },
  },

  validateText: {
    fontFamily: '"Montserrat", sans-serif',
    fontSize: "13.5px",
    fontWeight: "500",
    lineHeight: "23.625px",
    textAlign: "center",
    color: "#ffffff",
  },
});
export default ConfirmModal;